<template>
  <div class="list">
    <el-menu :default-active="listQuery.status" class="el-menu-demo" mode="horizontal" @select="handleStatus">
      <el-menu-item index="">全部</el-menu-item>
      <el-menu-item index="1">待处理</el-menu-item>
      <el-menu-item index="2">已处理</el-menu-item>
    </el-menu>

    <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
      <el-form-item label="选择搜索类型:">
        <el-select v-model="listQuery.search_type" style="width: 200px" clearable>
          <el-option label="姓名 " value="1"></el-option>
          <el-option label="手机号" value="2"></el-option>
          <el-option label="公司名称" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="listQuery.keyword_search"
          clearable
          style="width: 300px"
          class="name-input"
          placeholder="请输入关键词"
        />
      </el-form-item>

      <el-form-item class="add">
        <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
        <el-button v-if="hasExport" type="primary" size="small" icon="el-icon-plus" @click="exportExcel"
          >导出Excel</el-button
        >
      </el-form-item>
    </el-form>

    <el-table v-loading="listLoading" :data="list" border style="width: 100%">
      <el-table-column prop="create_time" label="提交时间" align="center" />
      <el-table-column prop="name" label="姓名" align="center" />
      <el-table-column prop="mobile" label="手机号" align="center" />
      <el-table-column prop="company_name" label="公司名称" align="center" />

      <el-table-column prop="sort" label="处理状态" width="80" align="center">
        <template slot-scope="scope">
          <span :class="scope.row.status === 1 ? 'current' : ''">{{
            scope.row.status === 1 ? "待处理" : "已处理"
          }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="remarks" label="备注" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="hasHandle && scope.row.status == 1"
            type="primary"
            size="mini"
            class="btn-wrap"
            @click="showDialog('handle', scope)"
            >确认处理</el-button
          >
          <el-button v-if="hasRemark" type="primary" size="mini" @click="showDialog('remark', scope)">备注</el-button>
          <el-button v-if="hasDelete" type="danger" size="mini" @click="handleDeleteClick(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>

    <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns">
      <el-form v-if="dialogType == 'remark'">
        <el-form-item label="备注内容" label-width="80px">
          <el-input
            v-model="remarks"
            type="textarea"
            :autosize="{ minRows: 6, minCols: 80 }"
            placeholder="请输入备注内容"
          ></el-input>
        </el-form-item>
        <el-form-item class="button_wrap">
          <el-button @click="dialogVisible = false">返回</el-button>
          <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
        </el-form-item>
      </el-form>

      <div v-if="dialogType == 'handle'">
        是否确认处理完成？
        <div class="button_wrap">
          <el-button @click="dialogVisible = false">返回</el-button>
          <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
        </div>
      </div>
    </common-dialog>
  </div>
</template>
<script>
import { getFormRecord, editFormRecord, deleteFormRecord } from "@/api/form";
import Pagination from "@/components/Pagination";
import CommonDialog from "@/components/CommonDialog";
import operations from "../../mixins/operations";
import utils from "@/jslibs/utils";
export default {
  components: { Pagination, CommonDialog },
  mixins: [operations],
  data() {
    return {
      id: "",
      remarks: "",
      showBtns: false,
      dialogTitle: "",
      dialogType: "",
      list: [],
      dialogVisible: false,
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
        type: 1,
        status: "",
        search_type: "",
        keyword_search: "",
      },
      listLoading: false,
    };
  },
  computed: {
    hasExport() {
      return this.operations.includes("导出Excel");
    },
    hasHandle() {
      return this.operations.includes("确认处理");
    },
    hasRemark() {
      return this.operations.includes("备注");
    },
    hasDelete() {
      return this.operations.includes("删除");
    },
  },
  async mounted() {
    this.getList();
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getFormRecord(params);
      this.listLoading = false;
      this.total = total;
      this.list = data;
    },

    // 导出excel
    async exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "正在努力下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const res = await utils.downloadFile("/v1/cms/FormRecordExcel", this.listQuery);
      utils.downloadBlobFile(res.data, `预约演示列表.xlsx`);
      loading.close();
    },

    handleStatus(val) {
      this.listQuery.status = val;
      this.getList();
      console.log(val, "44444");
    },

    showDialog(value, scope) {
      if (value == "handle") {
        this.dialogTitle = "确认处理";
        this.dialogType = value;
      } else if (value == "remark") {
        this.dialogTitle = "备注";
        this.dialogType = value;
        this.remarks = "";
      }
      this.id = scope.row.id;
      this.dialogVisible = true;
    },

    async dialogConfirmClick() {
      if (this.dialogType == "remark") {
        if (!this.remarks) {
          return this.$notify.error({ title: "请输入备注" });
        }
        const params = { remarks: this.remarks };
        const res = await editFormRecord(this.id, params);
        if (res == true) {
          this.getList();
          this.$notify.success({ title: "添加备注成功" });
          this.dialogVisible = false;
        } else {
          this.$notify.success({ title: "操作失败" });
        }
      } else if (this.dialogType == "handle") {
        const params = { status: "2" };
        const res = await editFormRecord(this.id, params);
        if (res == true) {
          this.getList();
          this.$notify.success({ title: "已处理完成" });
          this.dialogVisible = false;
        } else {
          this.$notify.error({ title: "操作失败" });
        }
      }
    },

    handleDeleteClick(id) {
      this.$confirm(`是否删除该演示列表？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await deleteFormRecord(id);
          this.getList();
          this.$notify({ title: "操作成功", type: "success" });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  padding-top: 0 !important;
  .el-menu-demo {
    margin-bottom: 20px;
  }
  .add {
    float: right;
    margin-bottom: 20px;
  }
  .button_wrap {
    text-align: center;
    margin-top: 30px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
  .btn-wrap {
    margin-bottom: 10px;
  }
  .current {
    color: red;
  }
}
</style>
